import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCodeBranch, faExternalLinkAlt, faFileLines } from "@fortawesome/free-solid-svg-icons";

import "./styles/project.css";

const Project = (props) => {
	const { logo, title, description, outcome, stack = [], github, live, path } = props;

	return (
		<React.Fragment>
			<div className="project">
				<div className="project-container">
					<div className="project-logo">
						<img
							src={logo}
							alt={`${title} technology logo`}
							width="30"
							height="30"
							decoding="async"
							loading="lazy"
						/>
					</div>
					<h3 className="project-title">{title}</h3>
					<div className="project-description">{description}</div>
					{outcome && <div className="project-outcome">{outcome}</div>}
					{stack.length > 0 && (
						<div className="project-stack">
							{stack.map((item) => (
								<span className="project-stack-item" key={item}>
									{item}
								</span>
							))}
						</div>
					)}
					<div className="project-links">
						{path && (
							<Link className="project-link" to={path}>
								<FontAwesomeIcon icon={faFileLines} />
								<span>Case Study</span>
							</Link>
						)}
						{github && (
							<a
								className="project-link"
								href={github}
								target="_blank"
								rel="noopener noreferrer"
							>
								<FontAwesomeIcon icon={faCodeBranch} />
								<span>GitHub</span>
							</a>
						)}
						{live && (
							<a
								className="project-link"
								href={live}
								target="_blank"
								rel="noopener noreferrer"
							>
								<FontAwesomeIcon icon={faExternalLinkAlt} />
								<span>Live</span>
							</a>
						)}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Project;
